import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { MessageCircle } from 'lucide-react';

/** Campo ricerca cliente con dropdown risultati e preview telefono WhatsApp. */
export const ClienteSearchField = ({ clienteSearch, results, selectedCliente, onSearchChange, onSelect }) => (
  <div className="relative">
    <Label className="text-xs font-mono uppercase">Cliente * (cerca per nome o P.IVA)</Label>
    <Input
      value={clienteSearch}
      onChange={(e) => onSearchChange(e.target.value)}
      placeholder="Digita e seleziona dalla lista..."
      className={`rounded-none ${selectedCliente ? 'border-success bg-success/5' : ''}`}
      data-testid="documento-cliente-search"
    />
    {results.length > 0 && !selectedCliente && (
      <div className="absolute z-50 w-full mt-1 bg-background border-2 border-primary shadow-lg max-h-48 overflow-y-auto">
        <div className="p-2 bg-muted text-xs font-mono uppercase text-muted-foreground">
          Clicca per selezionare:
        </div>
        {results.map((c) => (
          <div
            key={c.id}
            className="p-3 hover:bg-primary hover:text-primary-foreground cursor-pointer border-b border-border last:border-b-0 transition-colors"
            onClick={() => onSelect(c)}
            data-testid={`documento-cliente-result-${c.id}`}
          >
            <p className="font-bold">{c.ragione_sociale}</p>
            <p className="text-xs opacity-70">P.IVA: {c.partita_iva || '-'} | {c.citta_legale || ''}</p>
          </div>
        ))}
      </div>
    )}
    {selectedCliente && (
      <div className="mt-1.5 flex items-start gap-2 flex-wrap">
        <p className="text-xs text-success">✓ {selectedCliente.ragione_sociale}</p>
        {(selectedCliente.referente_cellulare || selectedCliente.telefono) ? (
          <span
            className="inline-flex items-center gap-1 text-[11px] text-green-600 bg-green-50 dark:bg-green-950/30 border border-green-500/40 px-1.5 py-0.5 rounded-sm"
            title="Numero che verra usato per l'invio del preventivo via WhatsApp"
            data-testid="documento-cliente-tel-preview"
          >
            <MessageCircle className="h-3 w-3" />
            WhatsApp: {selectedCliente.referente_cellulare || selectedCliente.telefono}
          </span>
        ) : (
          <span
            className="inline-flex items-center gap-1 text-[11px] text-amber-700 bg-amber-50 dark:bg-amber-950/30 border border-amber-500/40 px-1.5 py-0.5 rounded-sm"
            title="Senza numero non potrai inviare il preventivo via WhatsApp"
            data-testid="documento-cliente-tel-missing"
          >
            <MessageCircle className="h-3 w-3" />
            Cellulare assente - aggiungilo nella scheda cliente
          </span>
        )}
      </div>
    )}
    {clienteSearch.length >= 2 && results.length === 0 && !selectedCliente && (
      <p className="text-xs text-destructive mt-1">Nessun cliente trovato</p>
    )}
  </div>
);
